import { SnackbarProvider } from "notistack";
import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import Routes from "./app/Routes";
import { NavBar } from "./components";
import { SnackbarUtilsConfigurator } from "./helpers/toast";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm = urlParams.get("utm");

    if (utm && !localStorage.getItem("mpower_referral_code")) {
      localStorage.setItem("mpower_referral_code", utm);
    }
  }, []);

  return (
    <SnackbarProvider
      autoHideDuration={3000}
      maxSnack={3}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <ThemeProvider theme={theme}>
        <SnackbarUtilsConfigurator />
        <div className="App">
          <QueryClientProvider client={queryClient}>
            <HelmetProvider>
              <BrowserRouter>
                <NavBar />
                <Routes />
              </BrowserRouter>
            </HelmetProvider>
          </QueryClientProvider>
        </div>
      </ThemeProvider>
    </SnackbarProvider>
  );
};

export default App;
